import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceSubscriptionsApi } from "@/services/subscriptions/index";
import {
  SubscriptionAssignmentType,
  SubscriptionItemType,
} from "@/schemas/index";

const LayoutPageSubscription = lazy(() => import("./layout/index"));

export type LoaderDataSubscriptionType = {
  subscription: SubscriptionItemType;
  subscriptionId: string;
  activeAssignmentItems: SubscriptionAssignmentType[];
};

export const loaderDataSubscription = async (args: any) => {
  try {
    const { subscriptionId } = args.params;

    if (!subscriptionId) {
      throw new Error("SUBSCRIPTION_ID_REQUIRED");
    }

    const subscription =
      await serviceSubscriptionsApi.fetchSubscriptionById(subscriptionId);

    if (!subscription) {
      throw new Error("SUBSCRIPTION_NOT_FOUND");
    }

    return {
      subscription,
      subscriptionId,
      activeAssignmentItems: subscription?.ActiveAssignments || [],
    };
  } catch (err) {
    console.error(err);
    throw new Error("SUBSCRIPTION_NOT_FOUND");
  }
};

export const routerPageSubscription: RouterItemType = {
  path: "/subscriptions/:subscriptionId",
  authorize: true,
  element: <LayoutPageSubscription />,
  loader: loaderDataSubscription,
};
